/* eslint-disable */
import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => {
  const tips = document.querySelectorAll('.c-tip');
  if (!tips.length) return;

  tips.forEach(tip => {
    const close = tip.querySelector('.c-tip__close');
    const type = tip.dataset.type;
    const cookie = Cookies.get(`tip-${type}`);

    if (!cookie) {
      tip.classList.add('d-block');

      if (close) {
        close.addEventListener('click', () => {
          tip.classList.remove('d-block');
          Cookies.set(`tip-${type}`, 'hide', { expires: 20 });

          // Track event
          if (typeof gtag === 'function') {
            gtag('event', 'close', {
              'event_category': 'tip'
            });
          }
        });
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/scripts/modules/tip.js